import React, { useEffect } from 'react';

interface SchemaMarkupProps {
    schema: object | object[];
}

export const SchemaMarkup: React.FC<SchemaMarkupProps> = ({ schema }) => {
    useEffect(() => {
        const schemas = Array.isArray(schema) ? schema : [schema];
        const scripts: HTMLScriptElement[] = [];

        schemas.forEach(s => {
            const script = document.createElement('script');
            script.type = 'application/ld+json';
            script.text = JSON.stringify(s);
            document.head.appendChild(script);
            scripts.push(script);
        });

        return () => {
            scripts.forEach(script => {
                if (document.head.contains(script)) {
                    document.head.removeChild(script);
                }
            });
        };
    }, [JSON.stringify(schema)]);

    return null;
};
